module.exports={pagination:{DescribeReportDefinitions:{input_token:"NextToken",output_token:"NextToken",limit_key:"MaxResults"}}};